import isPropValid from '@emotion/is-prop-valid';
import { TextFieldProps } from '@mui/material';

/**
 *  A list of valid MUI props that should be forwarded to the MUI components.
 * Feel free to add more */

function isMUIStyleProp(prop: string): boolean {
    const validPaddingProps = ['p', 'px', 'py', 'pt', 'pb', 'pl', 'pr'];
    const validMarginProps = ['m', 'mx', 'my', 'mt', 'mb', 'ml', 'mr'];
    const otherValidProps = ['gap', 'sx', 'bgcolor'];

    const validMUIProps = [...validPaddingProps, ...validMarginProps, ...otherValidProps];
    return validMUIProps.includes(prop); // Using a type assertion to narrow the type
}

function isTextFieldProp(prop: string): prop is keyof TextFieldProps {
    const textfieldProps = ['onChange', 'variant', 'InputProps'];
    return textfieldProps.includes(prop);
}

function isAccordionProp(prop: string): boolean {
    const accordionProps = ['expandIcon'];
    return accordionProps.includes(prop);
}

function isSelectProp(prop: string): boolean {
    const selectProps = ['renderValue', 'icon', 'labelId', 'displayEmpty'];
    return selectProps.includes(prop);
}

function isStepperProp(prop: string): boolean {
    const stepperProps = ['activeStep'];
    return stepperProps.includes(prop);
}

export const shouldForwardProps = {
    shouldForwardProp: (prop: string) =>
        isAccordionProp(prop) ||
        isPropValid(prop) ||
        isTextFieldProp(prop) ||
        isMUIStyleProp(prop) ||
        isSelectProp(prop) ||
        isStepperProp(prop)
};
